<template>
  <div v-if="profile.name" class="relative flex items-center content-center pr-8 cursor-pointer group h-full userinfo">
    <div class="sm:pr-4 flex-shrink-0">
      <PersonAvatar
        :person="{
          name: {
            firstName: profile.name.firstName,
            lastName: profile.name.lastName
          },
          extSysApiUserId: profile.extSysApiUserId
        }"
        :tooltip="false"
      />
    </div>
    <div class="hidden sm:block font-semibold">
      {{ profile.name.firstName }}
    </div>
    <div class="ml-2 sm:ml-4 self-center">
      <svg
        class="fill-current opacity-50 w-2 transition-transform ease-out duration-200 rotate"
        viewBox="0 0 12 7"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M11 0L6 4 1 0 0 1l6 6 6-6-1-1z" />
      </svg>
    </div>

    <div class="absolute z-30" style="top: 80px; right: 5px; padding-top: 16px">
      <div class="bg-white flex flex-col text-black shadow-2xl w-50 max-h-0 overflow-hidden menu">
        <button
          class="p-4 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none text-16 text-gray-800 font-semibold hover:underline"
          @click="logout"
        >
          Log ud
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

import PersonAvatar from "@/components/People/PersonAvatar";
import Closable from "@/directives/Closable";
import { useFeaturesStore } from "@/stores/features";
import { useMeStore } from "@/stores/me";

export default {
  name: "UserInfo",

  setup() {
    return {
      featuresStore: useFeaturesStore(),
      meStore: useMeStore()
    };
  },

  data() {
    return {
      user: null,
      userProfileImage: "",
      showContextMenu: false,
      isCustomerAdmin: false
    };
  },

  computed: {
    profile() {
      return this.meStore.profile;
    }
  },

  isSensitivityLabelFeatureActive() {
    return this.featuresStore.isFeatureEnabled("DocumentSensitivityLabels");
  },

  async mounted() {
    this.isCustomerAdmin = await this.meStore.loadTemporaryCustomerAdmin();
  },

  methods: {
    onToggleContextMenu() {
      this.showContextMenu = !this.showContextMenu;
    },

    onHideContextMenu() {
      this.showContextMenu = false;
    },

    logout() {
      SessionHelper.logout();
    }
  },

  components: {
    PersonAvatar
  },
  directives: {
    Closable
  }
};
</script>

<style scoped>
.userinfo:hover .rotate {
  transform: rotate(-180deg);
}

.userinfo .menu {
  transition: height 200ms ease-out;
}

.userinfo:hover .menu {
  max-height: 300px;
}
</style>
